import { useState } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import HotVideos from "./components/HotVideos";
import Categories from "./components/Categories";
import VideoLibrary from "./components/VideoLibrary";
import Columns from "./components/Columns";
import FAQ from "./components/FAQ";
import About from "./components/About";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";

export default function Home() {
  const [keyword, setKeyword] = useState("");
  const [category, setCategory] = useState("all");
  const [length, setLength] = useState("all");

  const goLibrary = () => {
    document.getElementById("library")?.scrollIntoView({ behavior: "smooth" });
  };

  const handleSearch = (kw: string) => {
    setKeyword(kw);
    goLibrary();
  };

  const handlePickCategory = (key: string) => {
    setCategory(key);
    goLibrary();
  };

  return (
    <div className="w-full bg-background-50 text-foreground-950">
      <Navbar />
      <main>
        <Hero keyword={keyword} onSearch={handleSearch} onPickCategory={handlePickCategory} />
        <HotVideos />
        <Categories activeCategory={category} onPick={handlePickCategory} />
        <VideoLibrary
          keyword={keyword}
          category={category}
          length={length}
          onKeyword={setKeyword}
          onCategory={setCategory}
          onLength={setLength}
        />
        <Columns />
        <FAQ />
        <About />
        <Contact />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}